import axios from 'axios';
import {
  reportRequestFailure,
  reportRequestSuccess,
} from '../components/alliance/connection-monitor';

/**
 * Watch every API call for the connection banner. Amplify's API module
 * sends its requests through the default axios instance (as does
 * utils/form-data-request.ts), so one response interceptor sees the
 * react-query calls and the useEffect ones alike. Only network errors and
 * 5xx count as trouble; cancelled requests are ignored.
 */
export function installRequestMonitor() {
  axios.interceptors.response.use(
    (response) => {
      reportRequestSuccess();
      return response;
    },
    (error) => {
      if (!axios.isCancel(error)) {
        reportRequestFailure(error);
      }
      return Promise.reject(error);
    },
  );
}
